import { trainLevels, cumulativeLevels } from "@/lib/DonoTrainUtil";
import { donationFormatter } from "@/lib/utils";
import { FC } from "react";


export const DonoTrainInfo: FC = () => {
    return (
        <div className="col-span-12 flex flex-col gap-2 items-stretch max-w-3xl mx-auto">
            <div className="flex flex-col dark:bg-gray-800 px-5 pb-5 rounded-3xl">
                <h2 className="text-3xl font-bold self-center">Train States</h2>
                <ol className="list-decimal list-inside">
                    <li>
                        <span className="font-bold text-green-500">Ready</span>
                        <ul className="list-disc list-outside ml-10">
                            <li>The Train is off cooldown and ready to be triggered.</li>
                            <li>When a Donation is received the Train will transition to the <span className="text-orange-400">primed</span> state.</li>
                        </ul>
                    </li>
                    <li>
                        <span className="font-bold text-orange-400">Primed</span>
                        <ul className="list-disc list-outside ml-10">
                            <li>The Train is primed for departure.</li>
                            <li>The Train will remain in the <span className="text-orange-400">primed</span> state until the <span className="text-orange-400">Primed-Duration</span> set above expires or a 2nd Donation is received.</li>
                            <li>When a 2nd Donation is received the Train will transition to the <span className="text-teal-500">In-Progress</span> state.</li>
                            <li>When no further Donations are received the train will transition back to <span className="text-green-500">Ready</span>.</li>
                        </ul>
                    </li>
                    <li><span className="font-bold text-teal-500">In-Progress</span>
                        <ul className="list-disc list-outside ml-10">
                            <li>The Train is currently in progress. Receiving Donations increases the progress and levels.</li>
                            <li>When the <span className="text-teal-500">Progress-Duration</span> reaches 0 the Train will transition to the <span className="text-red-700">Cooldown</span> state.</li>
                            <li>Finishing a Level resets the countdown to the specified <span className="text-teal-500">Progress-Duration</span>.</li>
                        </ul>
                    </li>
                    <li>
                        <span className="font-bold text-red-700">Cooldown</span>
                        <ul className="list-disc list-outside ml-10">
                            <li>The Train is on cooldown and cannot be triggered.</li>
                            <li>When the <span className="text-red-700">Cooldown-Duration</span> reaches 0 the Train will transition back to <span className="text-green-500">Ready</span>.</li>
                        </ul>
                    </li>
                </ol>
            </div>
            <div className="flex flex-col dark:bg-gray-800 px-5 pb-5 rounded-3xl">
                <h2 className="text-3xl font-bold self-center">Level Requirements</h2>
                <p>
                    Donation Train Levels are loosely based on Bit Values of the regular Twitch Hype-Trains.<br/>
                    On average viewers end up paying approx. 20% less to reach the same levels while still giving the Streamers more support (due to Twitch not taking a cut).<br/>
                    <br/>
                    For further information and Feedback on how the levels are calculated, please refer to <a className="link" href="https://twitch.tv/ailenax">@Ailenax on Twitch.tv</a>.
                </p>
                <table className="w-full mt-5 border-white border-2 rounded-3xl">
                    <thead>
                        <tr>
                            <th className="w-fit">Level</th>
                            <th>Amount required</th>
                            <th>Total amount required</th>
                        </tr>
                    </thead>
                    <tbody>
                        { trainLevels.map((level, i) => (
                            <tr key={`${i}-${level}`}>
                                <td className="px-5 text-right">{i+1}</td>
                                <td className="px-5 text-right">{donationFormatter.format(level)}</td>
                                <td className="px-5 text-right">{donationFormatter.format(cumulativeLevels[i])}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}